wheelBonusPools = (() => {
  // create pools for the wheel bonus sprites and texts (some)
  const createSpritePool = ({ name, size, parentContainer, path, assetBuilder, initSprite, resetSprite }) => {
    const poolContainer = resourceManager.get(`${path}:poolContainer`);
    const pool = [];

    for (let i = 0; i < size; i++) {
      const sprite = resourceManager.createObject('sprite', `${name}PoolIndex:${i}`, poolContainer, assetBuilder(i));
      if (initSprite) initSprite(sprite, i);
      pool.push(sprite);
    }

    return {
      acquire: (x, y, rotation) => {
        if (pool.length === 0) {
          console.warn(`Pool "${name}" exhausted`);
          return null;
        }
        const sprite = pool.pop();
        sprite.x = x ?? sprite.x;
        sprite.y = y ?? sprite.y;
        sprite.rotation = rotation ?? sprite.rotation;
        parentContainer.addChild(sprite);
        return sprite;
      },
      release: (sprite) => {
        if (resetSprite) resetSprite(sprite);
        sprite.parent?.removeChild(sprite);
        poolContainer.addChild(sprite);
        pool.push(sprite);
      },
    };
  };

  const createMoviePool = ({ name, size, parentContainer, path, assetBuilder, initMovie, resetMovie }) => {
    const poolContainer = resourceManager.get(`${path}:poolContainer`);
    const pool = [];

    for (let i = 0; i < size; i++) {
      const movie = resourceManager.createObject('movie', `${name}PoolIndex:${i}`, poolContainer, assetBuilder(i));
      if (initMovie) initMovie(movie, i);
      pool.push(movie);
    }

    return {
      acquire: (x, y, rotation, onComplete) => {
        if (pool.length === 0) {
          console.warn(`Pool "${name}" exhausted`);
          return null;
        }
        const movie = pool.pop();
        movie.x = x ?? movie.x;
        movie.y = y ?? movie.y;
        movie.rotation = rotation ?? movie.rotation;
        movie.onComplete = function () {
          movie.gotoAndStop(0);
          movie.visible = false;
          onComplete && onComplete();
        };
        parentContainer.addChild(movie);
        return movie;
      },
      release: (movie) => {
        if (resetMovie) resetMovie(movie);
        movie.parent?.removeChild(movie);
        poolContainer.addChild(movie);
        pool.push(movie);
      },
    };
  };

  const createWheelSegmentPool = (name, path, assetName, size, parentContainer) =>
    createSpritePool({
      name,
      size,
      parentContainer,
      path,
      assetBuilder: () => ({
        anchor: 0.5,
        fileName: `WheelBonus/Wedges/${assetName}`,
        x: 0,
        y: 0,
      }),
      initSprite: (sprite) => {
        sprite.alpha = 0;
      },
      resetSprite: (sprite) => {
        sprite.alpha = 0;
        sprite.x = 0;
        sprite.y = 0;
        sprite.rotation = 0;
      },
    });

  const createGoldPigPool = (name, path, size, parentContainer) =>
    createSpritePool({
      name,
      size,
      parentContainer,
      path,
      assetBuilder: () => ({
        anchor: 0.5,
        fileName: `Base_Game/Pig_Gold.png`,
        x: 135,
        y: -480,
        scale: 0,
        rotation: 1.5,
      }),
      resetSprite: (sprite) => {
        sprite.scale.set(0);
        sprite.x = 135;
        sprite.y = -480;
      },
    });

  const createWheelSegmentMoviePool = (name, path, assetName, size, parentContainer) =>
    createMoviePool({
      name,
      size,
      parentContainer,
      path,
      assetBuilder: () => ({
        anchor: 0.5,
        definition: assetName,
        x: 0,
        y: 0,
        loop: false,
      }),
      initMovie: (movie) => {
        movie.visible = false;
        movie.gotoAndStop(0);
      },
      resetMovie: (movie) => {
        movie.x = 0;
        movie.y = 0;
        movie.rotation = 0;
      },
    });

  return {
    createWheelSegmentPool,
    createGoldPigPool,
    createWheelSegmentMoviePool,
  };
})();
